import { usePublicApi } from "api/setup";
import { ApiError } from "api/shared";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { ApiKeyData } from "./apiKeyData";

export const useGetApiKeys = () =>
  usePublicApi<ApiKeyData[], ApiError>(
    {
      url: api.apiKeys.all,
      method: "GET",
    },
    { manual: false }
  );

export const useDeleteApiKey = (id: string) =>
  usePublicApi<boolean, ApiError>(
    {
      url: formatUrl(api.apiKeys.one, { id }),
      method: "DELETE",
    },
    {
      manual: true,
    }
  );

export const useAddApiKey = () =>
  usePublicApi<ApiKeyData, ApiError>(
    { url: api.apiKeys.all, method: "POST" },
    { manual: true }
  );
